import { setterReducer } from "../common/redux"
import { combineReducers } from "redux"
import * as t from "./actionTypes"

const options = setterReducer([], t.SET_FOLLOW_UP_OPTIONS)
const response = setterReducer(null, t.SET_FOLLOW_UP_RESPONSE)
const text = setterReducer("", t.SET_FOLLOW_UP_TEXT)
const submitted = setterReducer(false, t.SET_FOLLOW_UP_SUBMITTED)
const specialistSuggestion = setterReducer("", t.SET_SPECIALIST_SUGGESTION)
const specialistOptions = setterReducer(
  [
    { text: "Orthopedic Surgeon", token: "Orthopedic Surgeon" },
    { text: "OB/GYN", token: "OB-GYN" },
    { text: "Gastroenterologist", token: "Gastroenterologist" },
    { text: "X-ray, MRI or other imaging", token: "Radiologist" },
    { text: "Other", token: "OTHER" },
  ],
  t.SET_SPECIALIST_OPTIONS
)

const followUp = combineReducers({
  options,
  response,
  text,
  submitted,
  specialistOptions,
  specialistSuggestion,
})

export { followUp as default }



// WEBPACK FOOTER //
// ./assets/feedback/followUp.js